import errorHandler from 'lib/utils/errorHandler';
import { fetchUserData, setNoRouteAccess } from 'apps/user/actions/user';

export default function ensureUserData(nextState, replace, path, extras) {
  const { store: { dispatch }, store } = extras;
  const { user } = store.getState();

  if (!user.received && !user.error) {
    return new Promise((resolve, reject) => {
      dispatch(fetchUserData())
        .then((userData) => {
          if (userData) {
            resolve();
          } else {
            dispatch(setNoRouteAccess());
            reject();
          }
        })
        .catch(e => {
          dispatch(setNoRouteAccess());
          reject();
          errorHandler(e);
        });
    });
  }

  if (user.error) {
    dispatch(setNoRouteAccess());
    return Promise.reject();
  }

  return Promise.resolve();
}
